import { render, staticRenderFns } from "./QueryFormSettings.vue?vue&type=template&id=53eb852c"
import script from "./QueryFormSettings.vue?vue&type=script&lang=ts"
export * from "./QueryFormSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports